<template>
    <div class="move">
        <div class="form-section">
            <label for="parent_id" class="label">{{ selectLabel }}</label>
            <v-select v-model="selectedListItem"
                :placeholder="this.trans('clients.label.select')"
                :options="this.selectList"
                @input="selectChanged()"
                class="form-vue-select"
            >
                <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
            </v-select>

            <move-group v-for="(group) in summary.groups" :key="group.id" :group="group">
            </move-group>
        </div>

        <div class="page-control">
            <div class="page-control__element" v-if="backUrl">
                <a :href="backUrl" class="btn btn--big btn--tertiary">
                        {{ trans('buttons.back') }}
                </a>
            </div>
            <div v-if="showButton">
                <div class="page-control__element" v-if="!checkSuccessful">
                    <button class="btn btn--big btn--primary" @click="check()">{{ trans('buttons.check') }}</button>
                </div>
                <div class="page-control__element" v-else>
                    <button class="btn btn--big btn--primary" @click="submit()">{{ trans('buttons.submit') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        "item": {
            required: true,
        },
        "selectList": {
            required: true,
        },
        "backUrl": {
            type: String,
        },
        "checkUrl": {
            type: String,
            required: true,
        },
        "submitUrl": {
            type: String,
            required: true,
        },
        "selectLabel": {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            selectedListItem: null,
            summary: [],
        }
    },
    computed: {
        showButton() {
            if(this.selectedListItem == null) {
                return false;
            }
            return this.status != 'danger';
        },
        checkSuccessful() {
            if (!this.summary.groups) {
                return false;
            }
            return this.summary.groups.length >= 1;
        },
        status() {
            if (this.summary.length == 0) {
                return 'nothing';
            }

            if (this.summary.groups.every(group => {
                return group.status == 'success';
            })) {
                return 'success';
            }
            if (this.summary.groups.some(group => {
                return group.status == 'danger';
            })) {
                return 'danger';
            }
            return 'warning';
        },
    },
    methods: {
        selectChanged() {
            this.summary = [];
        },
        check() {
            axios({
                method: 'post',
                url: this.checkUrl,
                data: {'item': this.item, 'selectedItem': this.selectedListItem.value}
            }).then((response) => {
                this.summary = response.data;
            });
        },
        submit() {
            axios({
                method: 'post',
                url: this.submitUrl,
                data: {'item': this.item, 'selectedItem': this.selectedListItem.value, 'summary': this.summary}
            }).then((response) => {
                // hack TODO: unhack it
                const link = document.createElement('a');
                link.href = response.data;
                document.body.appendChild(link);
                link.click();
            });
        },
    }
}
</script>
